import {IconProps} from '../icon-props-interface';
import '../icons.scss';

export const IconCircleNotRestockable = ({ color = 'var(--color-accent-3)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
            >
            <g clipPath="url(#clip0_76_63)">
                <path
                fill={color}
                d="M14.043 9.944a3.61 3.61 0 110 7.222 3.61 3.61 0 010-7.222zm0 8.056a4.444 4.444 0 100-8.889 4.444 4.444 0 000 8.889zm-1.406-5.85a.415.415 0 000 .588l.816.816-.816.816a.417.417 0 00.589.589l.815-.817.816.816a.417.417 0 00.588-.589l-.815-.815.816-.816a.416.416 0 00-.588-.588l-.817.815-.816-.816a.415.415 0 00-.588 0z"
                ></path>
            </g>
            <path
                fill={color}
                fillRule="evenodd"
                d="M9.384 12.018a4.77 4.77 0 00-.182.835h-2.52c-.13 0-.209-.078-.209-.208v-.418c0-.104.078-.209.209-.209h2.702zM14.173 2H4.154c-.94 0-1.67.757-1.67 1.67v10.018c0 .94.73 1.67 1.67 1.67h5.41a4.774 4.774 0 01-.277-.835H4.154a.824.824 0 01-.835-.835V3.67a.84.84 0 01.835-.835h10.019c.443 0 .835.391.835.835V8.8c.286.067.566.16.834.276V3.67c0-.913-.756-1.67-1.67-1.67zm-2.088 4.864v2.188a4.77 4.77 0 00-.817.442.25.25 0 01-.018-.096V6.864l-.939 1.148a.415.415 0 01-.574.079.448.448 0 01-.078-.6l1.67-2.088c.156-.182.495-.182.652 0l1.67 2.087c.156.183.104.444-.052.6a.44.44 0 01-.6-.078l-.914-1.148zM5.302 8.012l.94-1.148v2.534c0 .13.078.209.208.209h.417a.206.206 0 00.21-.21V6.865l.912 1.148a.44.44 0 00.6.079c.157-.157.21-.418.053-.6l-1.67-2.088c-.157-.182-.496-.182-.652 0L4.65 7.49a.448.448 0 00.078.6c.157.131.444.105.574-.078z"
                clipRule="evenodd"
            ></path>
            <defs>
                <clipPath id="clip0_76_63">
                <path
                    fill="#fff"
                    d="M0 0H8.889V8.889H0z"
                    transform="translate(9.599 9.111)"
                ></path>
                </clipPath>
            </defs>
        </svg>
    </div>
);

export default IconCircleNotRestockable;